import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/login",
  },

  {
    path: "/register",
    name: "Register",
    component: () => import("../views/center/Register.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/center/Login.vue"),
  },
  {
    path: "/reset_password",
    name: "ResetPassword",
    component: () => import("../views/center/ResetPassword.vue"),
  },
  {
    path: "/personal_info",
    name: "PersonalInfo",
    component: () => import("../views/center/PersonalInfo.vue"),
  },
  {
    path: "/ddf_vote_newer",
    name: "DdfVoteNewer",
    component: () => import("../views/other/DdfVoteNewer.vue"),
  },
  {
    path: "/ddf_vote_new",
    name: "DdfVoteNew",
    component: () => import("../views/other/DdfVoteNew.vue"),
  },
  {
    path: "/ddf_vote",
    name: "DdfVote",
    component: () => import("../views/other/DdfVote.vue"),
  },
  {
    path: "/ddf_vote_list",
    name: "DdfVoteList",
    component: () => import("../views/other/DdfVoteList.vue"),
  },
  {
    path: "/top_events",
    name: "TopEvents",
    component: () => import("../views/topEvents/Home.vue"),
    redirect: "/top_events/form",
    children: [
      {
        path: "form",
        name: "TopEventsForm",
        component: () => import("../views/topEvents/Form.vue"),
      },
      {
        path: "mylist",
        name: "TopEventsMyList",
        component: () => import("../views/topEvents/MyList.vue"),
      },
      {
        path: "list",
        name: "TopEventsList",
        component: () => import("../views/topEvents/List.vue"),
      },
      {
        path: "detail/:id",
        name: "TopEventsDetail",
        component: () => import("../views/topEvents/Detail.vue"),
      },
    ],
  },

  // 昌都文化大赛
  {
    path: "/chang_du",
    name: "ChangDu",
    component: () => import("../views/changDu/Home.vue"),
    redirect: "/chang_du/index",
    children: [
      {
        path: "index",
        name: "ChangDuIndex",
        component: () => import("../views/changDu/Index.vue"),
      },
      {
        path: "about",
        name: "ChangDuAbout",
        component: () => import("../views/changDu/About.vue"),
      },
      {
        path: "guide",
        name: "ChangDuGuide",
        component: () => import("../views/changDu/Guide.vue"),
      },
      {
        path: "award_setting",
        name: "ChangDuAwardSetting",
        component: () => import("../views/changDu/AwardSetting.vue"),
      },
      {
        path: "evaluation",
        name: "ChangDuEvaluation",
        component: () => import("../views/changDu/Evaluation.vue"),
      },
      {
        path: "sign_up",
        name: "ChangDuSignUp",
        component: () => import("../views/changDu/SignUp.vue"),
      },
      {
        path: "activities",
        name: "ChangDuActivities",
        component: () => import("../views/changDu/Activities.vue"),
      },
      {
        path: "exemption",
        name: "ChangDuExemption",
        component: () => import("../views/changDu/Exemption.vue"),
      },
    ],
  },
  // 龙腾之星大赛
  {
    path: "/dragon_star",
    name: "DragonStar",
    component: () => import("../views/dragonStar/Home.vue"),
    redirect: "/dragon_star/index",
    children: [
      {
        path: "index",
        name: "StarIndex",
        component: () => import("../views/dragonStar/Index.vue"),
      },
      {
        path: "about",
        name: "StarAbout",
        component: () => import("../views/dragonStar/About.vue"),
      },
      {
        path: "guide",
        name: "StarGuide",
        component: () => import("../views/dragonStar/Guide.vue"),
      },
      {
        path: "award_setting",
        name: "StarAwardSetting",
        component: () => import("../views/dragonStar/AwardSetting.vue"),
      },
      {
        path: "sign_up",
        name: "StarSignUp",
        component: () => import("../views/dragonStar/SignUp.vue"),
      },
      {
        path: "activities",
        name: "StarActivities",
        component: () => import("../views/dragonStar/Activities.vue"),
      },
      {
        path: "exemption",
        name: "StarExemption",
        component: () => import("../views/dragonStar/Exemption.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, from, next) => {
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(["_trackPageview", "/#" + to.fullPath]);
    }
  }
  next();
});

export default router;
